<template>
  <modal
    v-if="$modal"
    class="modal"
    :class="{
      'modal_w-footer': hasFooter
    }"
    :name="name"
    :pivotY="0.1"
    :width="width"
    :height="height"
    adaptive
    overlayTransition=""
    @opened="isVisible = true"
    @closed="isVisible = false"
    @before-open="$emit('before-open', $event)"
  >
    <div class="modal__body" ref="modalBody">
        <button v-if="closeButton" class="modal__close-button" @click="$modal.hide(name)">
          <img src="@/assets/icon-x.svg" />
        </button>

        <slot />
    </div>
    <footer v-if="hasFooter" class="modal__footer">
      <slot name="footer" />
    </footer>
  </modal>
</template>

<script>
import * as bodyScroll from 'tua-body-scroll-lock';

export default {
  props: {
    name: String,
    width: Number,
    height: {},
    closeButton: Boolean,
  },
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    hasFooter() {
      return Boolean(this.$slots.footer);
    },
  },
  methods: {
    lockScroll() {
      bodyScroll.lock(this.$refs.modalBody);
    },
    unlockScroll() {
      bodyScroll.unlock(this.$refs.modalBody);
    },
  },
  watch: {
    isVisible() {
      if (this.isVisible) {
        this.lockScroll();
      } else {
        this.unlockScroll();
      }
    },
  },
  beforeDestroy() {
    this.unlockScroll();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.modal {
  &::v-deep {
    .vm--modal {
      max-width: 100%;
      background-color: var(--bg);
      border: 2px solid var(--lighter-primary);
    }

    .vm--overlay {
      background: rgba(0, 0, 0, var(--modal-overlay-opacity));
    }
  }

  &_w-footer {
    .modal__body {
      padding-bottom: 10px;
    }
  }

  &__close-button {
    filter: var(--img-filter-inverted);
    position: absolute;
    top: 5px;
    right: 5px;

    img {
      width: 20px;
    }
  }

  &__body {
    position: relative;
    padding: 15px;
    overflow: auto;
    height: 100%;
  }

  &__footer {
    display: flex;
    padding: 10px 15px 15px;
    border-top: 1px solid var(--tertiary-accent);
  }
}
</style>
